module.exports = __webpack_public_path__ + "static/media/food-1.e6197e7a.png";